import axios from "axios";
import { clearLogoutData } from "../logout/action";
import { Master_Service_TEAMS_URL } from "../Url";

export const saveDeletTeamIdActions = {
  SAVE_DELETE_TEAM_PERSONID_SUCCESS: "SAVE_DELETE_TEAM_PERSONID_SUCCESS",
  SAVE_DELETE_TEAM_PERSONID_ERROR: "SAVE_DELETE_TEAM_PERSONID_ERROR",
};

export function saveDeletTeamsIdDetails(props) {
  const { access_token, values, partnerFirmId, partnerTeamId } = props;
  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + access_token,
        "Access-Control-Allow-Origin": "*",
      },
      url: `${Master_Service_TEAMS_URL}/deletePartnerTeamPersonId?partnerFirmId=${partnerFirmId}&partnerPersonId=${partnerTeamId}`,
      data: values,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(saveDeletTeamIdDetailsSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(saveDeletTeamIdDetailsError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(saveDeletTeamIdDetailsError(err));
          return err.response;
        }
      });
}

export function saveDeletTeamIdDetailsError(error) {
  return {
    type: saveDeletTeamIdActions.SAVE_DELETE_TEAM_PERSONID_ERROR,
    payload: error,
  };
}

export function saveDeletTeamIdDetailsSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: saveDeletTeamIdActions.SAVE_DELETE_TEAM_PERSONID_SUCCESS,
      payload: props,
    });
  };
}
